export enum DEBT_CONSOLIDATION_OPTIONS {
  REDUCE_REPAYMENTS = 'Reduce the repayments',
  REDUCE_INTEREST_RATE = 'Reduce the interest rate being charged',
  COMBINE_INTO_ONE = 'Combine them into one easy-to-manage repayment',
  OTHER = 'Other',
}
export const debtConsolidationOptions = Object.values(DEBT_CONSOLIDATION_OPTIONS)
export type DebtConsolidationOptions = (typeof debtConsolidationOptions)[number]
